export default "__VITE_ASSET__BjYTgaK8__"